package uz.ferro.shop.pages.admin.dict

import js.core.jso
import mui.material.FormControlVariant
import mui.material.TextField
import mui.system.Box
import mui.system.sx
import react.FC
import react.Props
import react.ReactNode
import react.dom.events.ChangeEvent
import react.dom.onChange
import react.useEffect
import react.useState
import uz.ferro.shop.Colors
import uz.ferro.shop.model.DictItem
import uz.ferro.shop.ui.HorizontalLayout
import uz.ferro.shop.ui.VerticalLayout
import web.cssom.LineStyle
import web.cssom.TextAlign
import web.cssom.integer
import web.cssom.px
import web.html.HTMLInputElement

external interface DictEditorProps : Props {
    var title: String?
    var item: DictItem?
    var onChange: ((DictItem) -> Unit)?
    var multiline: Boolean?
    var fixedMultiline: Boolean?
}

private data class LangItem(
    val id: String,
    val displayValue: String
)

val DictEditor = FC<DictEditorProps> { props ->
    var item by useState(props.item ?: DictItem())
    var currentLang by useState("uzLat")
    var langs by useState(
        listOf(
            LangItem("uzLat", "O‘zb"),
            LangItem("uzCyr", "Ўзб"),
            LangItem("ru", "Рус"),
            LangItem("en", "Eng"),
        )
    )

    fun getCurrentValue(): String {
        return when (currentLang) {
            "uzLat" -> item.textUzLat
            "uzCyr" -> item.textUzCyr
            "ru" -> item.textRu
            "en" -> item.textEn
            else -> ""
        }.orEmpty()
    }

    fun onUpdate(text: String) {
        val updated = when (currentLang) {
            "uzLat" -> item.copy(textUzLat = text)
            "uzCyr" -> item.copy(textUzCyr = text)
            "ru" -> item.copy(textRu = text)
            "en" -> item.copy(textEn = text)
            else -> item
        }
        item = updated
        props.onChange?.invoke(updated)
    }

    useEffect(props.item) {
        if (props.item != null) {
            item = props.item!!
        }
    }

    VerticalLayout {
        TextField {
            label = ReactNode(props.title)
            variant = FormControlVariant.outlined
            value = getCurrentValue()
            InputLabelProps = jso {
                shrink = true
            }
            multiline = props.multiline == true || props.fixedMultiline == true
            if (props.multiline == true) {
                maxRows = 5
            }

            if (props.fixedMultiline == true) {
                minRows = 5
                maxRows = 5
            }

            onChange = { event ->
                event as ChangeEvent<HTMLInputElement>
                onUpdate(event.target.value)
            }
        }

        HorizontalLayout {
            langs.forEach { lang ->
                Box {
                    sx {
                        paddingLeft = 8.px
                        paddingRight = 8.px
                        paddingTop = 4.px
                        paddingBottom = 4.px
                        minWidth = 60.px
                        textAlign = TextAlign.center
                        borderBottomLeftRadius = 8.px
                        borderBottomRightRadius = 8.px
                        borderStyle = LineStyle.solid
                        borderWidth = 1.px
                        borderColor = Colors.accentColor
                        fontSize = 16.px
                        fontWeight = integer(500)
                        if (currentLang == lang.id) {
                            backgroundColor = Colors.accentColor
                            color = Colors.accentContrastColor
                        } else {
                            color = Colors.accentColor
                        }
                    }
                    onClick = {
                        currentLang = lang.id
                    }
                    +lang.displayValue
                }
            }
        }

        Box {
            sx {
                height = 8.px
            }
        }
    }
}